import React, { useState, useEffect } from 'react';
import { ArrowUpRight } from 'lucide-react';
import { useCountryLink } from '../context/CountryContext';

const StickyCTA = () => {
  const { link } = useCountryLink();
  const [show, setShow] = useState(false);

  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        setShow(window.scrollY > window.innerHeight * 0.9);
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Get MBE Alert Now on Telegram"
      className={`fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 bg-[#FF6E00] hover:bg-[#FF8533] text-white font-medium text-[13.5px] px-5 py-3 rounded-full transition-all duration-300 shadow-[0_18px_40px_-12px_rgba(255,110,0,0.7)] ${
        show ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
      style={{ fontFamily: "'Nacelle', sans-serif" }}
    >
      Get MBE Alert Now
      <ArrowUpRight className="w-4 h-4" />
    </a>
  );
};

export default StickyCTA;
